import { Box, ButtonBase, Link } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';

import { ContentComponentFactory } from '~/components/MyWorkspace/ListWidget/components/Content';
import { useNotificationList } from '~/hooks/useNotificationList';
import { LegacyFAIcon, LegacyFAIcons } from '~/legacy-components/LegacyFAIcon';
import { Notification } from '~/scenes/MyWorkspace/components/Widgets/components/MyNotificationsWidget/components/Notification';

import { useSxStyles } from './useStyles';

type Props = { isPage?: boolean; hasBorder?: boolean };

const Content = ContentComponentFactory({ ListItemComponent: Notification });

export const LegacyNotificationList: React.FC<Props> = ({
  isPage,
  hasBorder,
}) => {
  const { t } = useTranslation();
  const sxStyles = useSxStyles();
  const {
    loading,
    failedToLoad,
    notifications,
    onDeleteAll,
    onDeleteNotification,
    onMarkAllAsRead,
    onMarkAsRead,
    onMarkAsUnread,
  } = useNotificationList({ limit: 50 });

  return (
    <Box sx={sxStyles.notificationList}>
      <Box
        sx={
          isPage
            ? sxStyles.notificationListTopPage
            : sxStyles.notificationListTop
        }
      >
        {!!isPage && (
          <LegacyFAIcon
            FAIcon={LegacyFAIcons.BellOutlined}
            sx={sxStyles.notificationIcon}
          />
        )}
        <Box
          component={'span'}
          sx={{ ...sxStyles.title, ...(isPage ? sxStyles.pageTitle : {}) }}
        >
          {t('laNotification')}
        </Box>
        <Box component={'span'} sx={sxStyles.paperActions}>
          {!isPage && (
            <Link
              component={RouterLink}
              to="/allNotifications"
              sx={{
                ...sxStyles.allNotificationsLink,
                ...sxStyles.paperAction,
              }}
            >
              {t('laSeeAll')}
            </Link>
          )}
          <ButtonBase
            onClick={onMarkAllAsRead}
            sx={{
              ...sxStyles.btnLink,
              ...(isPage ? sxStyles.paperActionPage : sxStyles.paperAction),
            }}
          >
            <LegacyFAIcon
              FAIcon={LegacyFAIcons.Flag}
              sx={sxStyles.markAllReadIcon}
            />
            {t('laMarkRead')}
          </ButtonBase>
          {!!isPage && (
            <ButtonBase
              onClick={onDeleteAll}
              sx={{
                ...sxStyles.btnLink,
                ...sxStyles.deleteAllLink,
                ...(isPage ? sxStyles.paperActionPage : sxStyles.paperAction),
              }}
            >
              <LegacyFAIcon
                FAIcon={LegacyFAIcons.Delete}
                sx={sxStyles.markAllReadIcon}
              />
              {t('laDeleteAll')}
            </ButtonBase>
          )}
        </Box>
      </Box>
      <Box sx={!isPage ? sxStyles.notificationListItems : undefined}>
        <table id="idTableHeaderNotis" className="sfTableNoti"></table>
        <Content
          listItemsLoading={loading}
          listItems={isPage ? notifications : notifications?.slice(0, 19)}
          failedToLoadListItems={failedToLoad}
          noDataMessage={t('noNotifications')}
          getIdentifier={(item) => item.id}
          isOldUi={true}
          hasBorder={hasBorder}
          customActions={{
            onMarkAsRead,
            onDeleteNotification,
            onMarkAsUnread,
          }}
        />
      </Box>
    </Box>
  );
};
